import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const FichaValidacion = ({ datos, onValidarClick }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Identificador</TableCell>
            
            <TableCell>Estado de Validación</TableCell>
            <TableCell>Numero de Documento del Cliente</TableCell>
            <TableCell>Nombre del Cliente</TableCell>
            <TableCell>observacion</TableCell>
            <TableCell>usuario</TableCell>
            <TableCell>numero_contactado</TableCell>
            <TableCell>Acción</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datos.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.cliente__identificador}</TableCell>
              
              <TableCell>{row.estado_validacion__estado_validacion}</TableCell>
              <TableCell>{row.cliente__numero_documento}</TableCell>
              <TableCell>  
                            {
                              row.cliente__nombre_completo ? 
                              row.cliente__nombre_completo : 
                              `${row.cliente__nombre} ${row.cliente__apellido_paterno}${row.cliente__apellido_materno ? ` ${row.cliente__apellido_materno}` : ''}`
                            }
              </TableCell>
              <TableCell>{row.observacion}</TableCell>
              <TableCell>{row.codigo_usuario}</TableCell>
              <TableCell>{row.numero_contacto}</TableCell>
              <TableCell>
                <IconButton onClick={() => onValidarClick(row)}>
                  <CheckCircleIcon />
                </IconButton>
           
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FichaValidacion;
